package pl.michal_cyran.portfolio.education.domain


data class Subject(
    val name: String,
    val category: SubjectCategory
)